'use server';
import { actionErrorLog } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { getAudioStoryService } from '@/contexts/audio-stories/services/AudioStoryService';

export async function updateVoiceSettings(
  audioStoryId: string,
  settings: { defaultVoiceId?: string; defaultVoiceName?: string; voiceModel?: string; voiceStability?: number; voiceSimilarity?: number; voiceQuality?: 'standard' | 'premium' },
): Promise<ActionResult<void>> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };

  try {
    await getAudioStoryService().updateVoiceSettings(audioStoryId, familyId, settings);
    return { success: true, data: undefined };
  } catch (e: unknown) {
    actionErrorLog('updateVoiceSettings', e);
    return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
  }
}
